import styled from 'styled-components/macro'

export const LogoImage = styled.img`
  height: 60px;
`
